<template>
  <PSOrgOpen />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
